import { Actor, CollisionType, SpriteSheet } from "excalibur";
import { Resources } from "../Resources";
import { inventoryState } from "../state/stateManager";

export default class HoneyStand extends Actor {
  constructor(pos, setCollision) {
    super({
      x: pos.x,
      y: pos.y,
      width: 30,
      height: 10,
      collisionType: CollisionType.Fixed,
      name: "honeyStandContainer",
    });

    this.honeyStandCollider = new Actor({
      width: 33,
      height: 12,
      collisionType: CollisionType.Passive,
      name: "honeyStandCollider",
    });
    this.addChild(this.honeyStandCollider);
    this.honeyStandCollider.on("collisionstart", (e) => {
      if (!this.indicationShowing && e.other.owner.name === "player") {
        console.log("collided with honeyStand");
        setCollision.setCollision("honeyStand");
        this.createNotification();
      }
    });
    this.honeyStandCollider.on("collisionend", () => {
      if (this.indicationShowing) {
        setCollision.setCollision(false);
        this.destroyNotification();
      }
    });
  }
  createNotification() {
    this.indicationShowing = true;
    this.noti = document.getElementById("hive-indication");
    this.noti.classList.add("showingGained");
    this.noti.style.bottom = 0;
    this.noti.style.height = "60px";
    this.noti.style.padding = "10px";
    this.noti.style.display = "block";
    this.noti.innerHTML = `<p id="notification">SPACE: Manage Stand</p>`;
  }
  destroyNotification() {
    this.indicationShowing = false;
    if (this.noti) {
      this.noti.classList.remove("showingGained");
      this.noti.innerHTML = ``;
      this.noti.style.bottom = "-400px";
      this.noti.style.display = "none";
    }
  }
  onInitialize() {
    const honeyStandSprites = SpriteSheet.fromImageSource({
      image: Resources.HoneyStand,
      grid: {
        spriteWidth: 44,
        spriteHeight: 32,
        rows: 1,
        columns: 2,
      },
    });
    this.stocked = honeyStandSprites.getSprite(0, 0);
    this.graphics.add("stocked", this.stocked);
    this.empty = honeyStandSprites.getSprite(1, 0);
    this.graphics.add("empty", this.empty);

    this.graphics.use("empty");
  }
  onPostUpdate() {
    this.inventory = inventoryState.getInventory();

    if (this.inventory.honeyStand.jars > 0) {
      this.graphics.use("stocked");
    } else {
      this.graphics.use("empty");
    }
  }
}
